import { PostSubmissionPresenter } from '@/presentation/presenters/judge/postSubmissionPresenter'
import { PostSubmissionViewModel } from '@/presentation/viewmodels/judge/postSubmissionViewModel'

export function usePostSubmissionPresenter(
  presenter: PostSubmissionPresenter = new PostSubmissionPresenter(new PostSubmissionViewModel())
) {
  return {
    judgeToken: presenter.judgeToken,
    isLoading: presenter.isLoading,
    error: presenter.error,
    postSubmission: presenter.postSubmission.bind(presenter)
  }
}
